"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAfter = addAfter;
exports.addChangeContractAndAfter = addChangeContractAndAfter;
exports.addContractAfterSalesApply = addContractAfterSalesApply;
exports.addContractPaySalesApply = addContractPaySalesApply;
exports.addContractSpecialApply = addContractSpecialApply;
exports.addContractUrgentApply = addContractUrgentApply;
exports.addOldContractAndAfter = addOldContractAndAfter;
exports.addPaySales = addPaySales;
exports.addReplenishmentCreate = addReplenishmentCreate;
exports.checkContractNo = checkContractNo;
exports.countCS = countCS;
exports.default = void 0;
exports.downloadAllAndCust = downloadAllAndCust;
exports.downloadCS = downloadCS;
exports.editContractAfter = editContractAfter;
exports.getContractAfterInfo = getContractAfterInfo;
exports.getContractOrderAttachments = getContractOrderAttachments;
exports.getContractSpecialApplyList = getContractSpecialApplyList;
exports.getHistoryContractList = getHistoryContractList;
exports.getOldBomList = getOldBomList;
exports.getOldOrderList = getOldOrderList;
exports.getOrderQuote = getOrderQuote;
exports.getOtherOldBom = getOtherOldBom;
exports.manualSyncByContract = manualSyncByContract;
exports.queryContract = queryContract;
exports.queryContractAll = queryContractAll;
exports.queryModifySupplement = queryModifySupplement;
exports.queryModifySupplementV2 = queryModifySupplementV2;
exports.queryOriginal = queryOriginal;
exports.subPay = subPay;
exports.subReceive = subReceive;
exports.syncBomList = syncBomList;
exports.syncProductionNum = syncProductionNum;

var _request = _interopRequireDefault(require("@/utils/request"));

// 新增特殊申请
function addContractSpecialApply(data) {
  return (0, _request.default)({
    url: 'api/contractSpecialApply',
    method: 'post',
    data: data
  });
} // 查询全部特殊申请列表


function getContractSpecialApplyList(params) {
  return (0, _request.default)({
    url: 'api/contractSpecialApply/all',
    method: 'get',
    params: params
  });
} // 新增加急申请


function addContractUrgentApply(data) {
  return (0, _request.default)({
    url: 'api/contractSpecialApply/urgentApply',
    method: 'post',
    data: data
  });
} // 新增结案申请


function addContractAfterSalesApply(data) {
  return (0, _request.default)({
    url: 'api/contractSpecialApply/afterSales',
    method: 'post',
    data: data
  });
} // 新增报价确认申请


function addContractPaySalesApply(data) {
  return (0, _request.default)({
    url: 'api/contractSpecialApply/paySales',
    method: 'post',
    data: data
  });
} // 批量确认报价（仅确认）


function addPaySales(data) {
  return (0, _request.default)({
    url: 'api/contractSpecialApply/addPaySales',
    method: 'post',
    data: data
  });
} // 获取报价信息


function getOrderQuote(params) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/getOrderQuote',
    method: 'get',
    params: params
  });
} // 查询合同列表


function queryContract(params) {
  return (0, _request.default)({
    url: 'api/contract/queryContract',
    method: 'get',
    params: params
  });
} // 查询全部合同（合同选择弹窗用）


function queryContractAll(params) {
  return (0, _request.default)({
    url: 'api/contract/all',
    method: 'get',
    params: params
  });
} // 导出合同及客户信息（按查询条件和导出字段）


function downloadAllAndCust(params) {
  return (0, _request.default)({
    url: 'api/contract/downloadAllAndCust',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
} // 改单（创建合同并售后）


function addChangeContractAndAfter(data) {
  return (0, _request.default)({
    url: 'api/contract/addChangeContractAndAfter',
    method: 'post',
    data: data
  });
} // 补单


function addAfter(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/addAfter',
    method: 'post',
    data: data
  });
} // 旧数据改补提交


function addReplenishmentCreate(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/addAfterOld',
    method: 'post',
    data: data
  });
} // 旧数据改单


function addOldContractAndAfter(data) {
  return (0, _request.default)({
    url: 'api/contract/addOldContractAndAfter',
    method: 'post',
    data: data
  });
} // 获取合同改补信息


function getContractAfterInfo(contractId) {
  return (0, _request.default)({
    url: 'api/contract/getContractAfterInfo',
    method: 'get',
    params: {
      contractId: contractId
    }
  });
} // 查询改补页面合同列表


function queryModifySupplement(params) {
  return (0, _request.default)({
    url: 'api/contract/queryModifySupplement',
    method: 'get',
    params: params
  });
} // 查询旧库合同（历史数据）


function getHistoryContractList(params) {
  return (0, _request.default)({
    url: '/api/cmsCustBom/getOrderList',
    method: 'get',
    params: params
  });
} // 查询原合同号


function queryOriginal(params) {
  return (0, _request.default)({
    url: 'api/contract/queryOriginal',
    method: 'get',
    params: params
  });
} // 统计合同状态数量


function countCS(params) {
  return (0, _request.default)({
    url: 'api/contract/countCS',
    method: 'get',
    params: params
  });
} // 编辑改补信息（改补信息、审核信息）


function editContractAfter(data) {
  return (0, _request.default)({
    url: 'api/contractAfter',
    method: 'put',
    data: data
  });
} // 确认付款


function subPay(data) {
  return (0, _request.default)({
    url: '/api/contractAfter/subPay',
    method: 'put',
    data: data
  });
} // 确认收款


function subReceive(data) {
  return (0, _request.default)({
    url: '/api/contractAfter/subReceive',
    method: 'put',
    data: data
  });
}

function downloadCS(params) {
  return (0, _request.default)({
    url: 'api/contract/downloadCS',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
} // 按合同号查询订单附件（报表接口）


function getContractOrderAttachments(data) {
  return (0, _request.default)({
    url: 'api/report/post',
    method: 'post',
    data: data
  });
} // 查询改补列表（新版单级表格）
// 同步生产数量（订单层级更新用）


function syncProductionNum(params) {
  return (0, _request.default)({
    url: 'api/contract/syncProductionNum',
    method: 'get',
    params: params
  });
} // 同步酷家乐物料


function syncBomList(contractNo) {
  return (0, _request.default)({
    url: '/api/cmsCustBom/syncBomList',
    method: 'get',
    params: {
      contractNo: contractNo
    }
  });
} // 查询旧库其他物料


function getOtherOldBom(params) {
  return (0, _request.default)({
    url: '/api/cmsCustBom/getOtherOldBom',
    method: 'get',
    params: params
  });
} // 查询旧库原单号列表


function getOldOrderList(params) {
  return (0, _request.default)({
    url: '/api/contract/getOldOrderList',
    method: 'get',
    params: params
  });
} // 查询旧库BOM物料


function getOldBomList(params) {
  return (0, _request.default)({
    url: '/api/cmsCustBom/getOldBom',
    method: 'get',
    params: params
  });
} // 查询改补列表（新版单级表格）


function queryModifySupplementV2(params) {
  return (0, _request.default)({
    url: '/api/cmsCustDesignSchemeAudit/selectAuditPageList',
    method: 'get',
    params: params
  });
} // 校验合同号是否存在


function checkContractNo(contractNo) {
  return (0, _request.default)({
    url: 'api/contract/checkContractNo?contractNo=' + contractNo,
    method: 'get'
  });
} // 手动同步合同


function manualSyncByContract(contractNo) {
  return (0, _request.default)({
    url: 'api/contract/manualSyncByContract?contractNo=' + contractNo,
    method: 'get'
  });
}

var _default = {
  addContractSpecialApply: addContractSpecialApply,
  getContractSpecialApplyList: getContractSpecialApplyList,
  addContractUrgentApply: addContractUrgentApply,
  addContractAfterSalesApply: addContractAfterSalesApply,
  addContractPaySalesApply: addContractPaySalesApply,
  addPaySales: addPaySales,
  getOrderQuote: getOrderQuote,
  queryContract: queryContract,
  queryContractAll: queryContractAll,
  addChangeContractAndAfter: addChangeContractAndAfter,
  addAfter: addAfter,
  getHistoryContractList: getHistoryContractList,
  getContractAfterInfo: getContractAfterInfo,
  queryModifySupplement: queryModifySupplement,
  queryOriginal: queryOriginal,
  countCS: countCS,
  downloadCS: downloadCS,
  editContractAfter: editContractAfter,
  subPay: subPay,
  subReceive: subReceive,
  queryModifySupplementV2: queryModifySupplementV2,
  syncBomList: syncBomList,
  syncProductionNum: syncProductionNum,
  getOldBomList: getOldBomList,
  getOtherOldBom: getOtherOldBom,
  getOldOrderList: getOldOrderList,
  addReplenishmentCreate: addReplenishmentCreate,
  addOldContractAndAfter: addOldContractAndAfter,
  checkContractNo: checkContractNo,
  manualSyncByContract: manualSyncByContract,
  getContractOrderAttachments: getContractOrderAttachments
};
exports.default = _default;